import { API_BASE_URL } from "src/config/api";
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { Button, CircularProgress, Container, Grid, Stack, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { EditModal, UserItem } from '../sections/@dashboard/profile';
import Iconify from '../components/iconify';

export default function ProfilePage() {
  const [users, setUsers] = useState([]);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('userId');
  const fetchUser = useCallback(async () => {
    setIsLoading(true);
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const response = await axios.get(`${API_BASE_URL}/getUserById?userId=${userId}`, config);
      const userData = response.data.data;
      setUsers([userData]);
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  }, [token, userId, setUsers]);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setEditModalOpen(false);
  };

  const handleSaveUser = async (updatedUser) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const url = `${API_BASE_URL}/updateUser?userId=${userId}`;
      const response = await axios.post(url, updatedUser, config);

      if (response.data.success) {
        toast.success('User details updated successfully.')
        setUsers([updatedUser]);
        fetchUser();
      } else {
        console.error('Error updating user data:', response.data.message);
      }
    } catch (error) {
      console.error('Error updating user data:', error);
    } finally {
      setIsLoading(false);
    }
    setEditModalOpen(false);
  };

  return (
    <>
      <Helmet>
        <title>Profile | WatchNod</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3" gutterBottom>
            Profile
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:edit-fill" />}
            onClick={() => handleEditClick(users[0])}
          >
            Personal Details
          </Button>
        </Stack>
          {isLoading ? (
            <CircularProgress />
          ) : (
            <>
              <Grid container spacing={3}>
                {users.map((user) => (
                  <Grid item xs={12} key={user._id}>
                    <UserItem user={user} />
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        {selectedUser && (
          <EditModal isOpen={editModalOpen} user={selectedUser} onClose={handleCloseModal} onSave={handleSaveUser} />
        )}
      </Container>
    </>
  );
}
